<!-- <div *ngIf="(upload$ | async) as percentage"> -->
<div *ngIf="(upload$ | async) as percentage">
  <div class="upload-progress-container">
    <span class="status status-ongoing" *ngIf="percentage > 0 && percentage < 100"> File Upload
      Ongoing</span>
    <span class=" status status-success" *ngIf="percentage == 100"> File Upload
      Completed
      <span class="material-symbols-outlined">
        done
      </span>
    </span>
    <div class="upload-progress d-flex">
      <div class="d-flex flex-column align-items-end justify-content-end w-100">
        <span class="ml-auto mb-1">{{percentage / 100 | percent}}</span>
        <mat-progress-bar class="file-upload-progress" [ngStyle]="calculateStyles()" mode="determinate"
          [value]="percentage">

        </mat-progress-bar>
      </div>
      <div class="cancel-upload" (click)="cancelUpload()">
        <span class="material-symbols-outlined">
          close
        </span>
      </div>
    </div>
  </div>
</div>